// Optymalizacja zdjęć przez Netlify Image CDN:
// - zmniejsza do potrzebnego rozmiaru,
// - konwertuje do nowoczesnego formatu (AVIF/WebP wg przeglądarki),
// - agresywnie cache'uje na brzegu sieci.
// W dev (localhost) i dla obrazów spoza Supabase zwraca oryginalny URL.

const SUPABASE_HOST = 'cyvedwbsxfcogevhgzya.supabase.co';

function onNetlify() {
  if (typeof window === 'undefined') return false;
  const h = window.location.hostname;
  return !(h === 'localhost' || h === '127.0.0.1' || h === '::1' || h === '0.0.0.0');
}

export function img(url, { w, h, q = 75, fit } = {}) {
  if (!url || typeof url !== 'string') return url;
  if (!url.startsWith('http')) return url;      // obraz z bundla (fallback)
  if (!url.includes(SUPABASE_HOST)) return url; // tylko nasze zdjęcia z Supabase
  if (/\.(heic|heif)(\?|$)/i.test(url)) return url; // Image CDN nie dekoduje HEIC (zwraca 500)
  if (!onNetlify()) return url;                 // lokalnie brak Netlify Image CDN

  const p = new URLSearchParams();
  p.set('url', url);
  if (w) p.set('w', String(w));
  if (h) p.set('h', String(h));
  if (fit) p.set('fit', fit);
  p.set('q', String(q));
  return `/.netlify/images?${p.toString()}`;
}
